import { LinkWrap } from '@/components/blocks/Linkable';
import {
	headerMobileBreadcrumbMenuIconSX,
	headerMobileBreadcrumbMenuItemLinkSX,
	headerMobileBreadcrumbTypographyMainSX,
} from '@/components/content/Header/styles/mobileDrawer';
import { PageLink } from '@/data/Navigation';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Link, Typography } from '@mui/material';

export const BreadcrumbLink = ({
	label,
	onClick,
	url,
}: {
	label: string;
	onClick: () => void;
	url?: string;
}) => (
	<Link href={url} color="inherit" onClick={onClick}>
		<Typography variant="h6" sx={headerMobileBreadcrumbTypographyMainSX}>
			{label}
		</Typography>
	</Link>
);

export const BreadcrumbMenuItemLinkWrap = ({ url, label }: { url?: string; label: string }) => (
	<LinkWrap href={url}>
		<Link sx={headerMobileBreadcrumbMenuItemLinkSX}>
			<Typography
				variant="subtitle1"
				sx={(theme) => ({
					color: theme.palette.text.primary,
					fontWeight: 'bold',
					fontSize: 'var(--font-size-default)',
				})}
			>
				{label}
			</Typography>
		</Link>
	</LinkWrap>
);

export const BreadcrumbMenuItemLinkExpand = ({
	label,
	level,
	onClick,
}: {
	label: string;
	level: number;
	onClick: () => void;
}) => (
	<Link sx={headerMobileBreadcrumbMenuItemLinkSX} onClick={onClick}>
		<Typography
			variant="h6"
			textTransform={level === 0 ? 'uppercase' : undefined}
			sx={(theme) => ({
				color: theme.palette.text.primary,
				fontWeight: level === 0 ? '900' : 'bold',
				fontSize: level === 0 ? '18px' : '16px',
			})}
		>
			{label}
		</Typography>
		<ArrowForwardIosIcon sx={headerMobileBreadcrumbMenuIconSX} />
	</Link>
);

export const BreadcrumbMenuItem = ({
	label,
	url,
	childrenPageLink,
	level,
	onClick,
}: {
	label: string;
	url?: string | undefined;
	childrenPageLink: PageLink[];
	level: number;
	onClick: () => void;
}) => {
	if (childrenPageLink.length > 0) {
		return <BreadcrumbMenuItemLinkExpand label={label} level={level} onClick={onClick} />;
	}

	return <BreadcrumbMenuItemLinkWrap url={url} label={label} />;
};
